module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/icon_trash_48x48_hover_VA.7f7dba93.svg";